import React from "react";
import FAQAccordion from "./FAQAccordion";
import { useParams, useNavigate } from "react-router-dom";

const Homepage: React.FC = () => {
  const { vendedorId } = useParams();
  const navigate = useNavigate();

  const handleClick = () => {
    const id = vendedorId ?? "000";
    navigate(`/form/${id}`);
  };

  return (
    <div className="flex flex-col bg-[#f5f5f5]">
      <div
        className="responsive-bg flex flex-col md:flex-row-reverse lg:flex-row-reverse w-full md:w-[100%] lg:w-[100%]"
        style={{
          backgroundImage: `
      url('https://nexxmed.com.br/wp-content/uploads/2025/05/Background-Mobile.png')
    `,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <style>
          {`
      @media (min-width: 768px) {
        div.responsive-bg {
          background-image: url('https://nexxmed.com.br/wp-content/uploads/2025/05/Background.png') !important;
        }
      }
    `}
        </style>

        <div className="p-5">
          <img
            src="https://nexxmed.com.br/wp-content/uploads/2025/05/Especialistas-1.png"
            srcSet="
    https://nexxmed.com.br/wp-content/uploads/2025/05/Especialistas-1-300x219.png 300w,
    https://nexxmed.com.br/wp-content/uploads/2025/05/Especialistas-1-768x560.png 768w,
    https://nexxmed.com.br/wp-content/uploads/2025/05/Especialistas-1.png 905w
  "
            sizes="(max-width: 905px) 100vw, 905px"
            alt="Especialistas"
            className="w-full h-auto"
          />
        </div>
        <div className="flex flex-col items-center justify-center text-center md:items-start lg:items-start md:pl-16 lg:pl-16 md:w-[80%] lg:w-[80%]">
          <div className="-mt-14 mb-3 flex items-center justify-center md:justify-start lg:justify-start md:mt-16 lg:mt-16 md:mb-8 lg:mb-8 md:items-start lg:items-start">
            <img src="https://nexxmed.com.br/wp-content/uploads/2024/09/logo_nexxmed.png" alt="" className="w-[50%]" />
          </div>
          <div className="flex flex-col items-center justify-center text-center md:text-start lg:text-start md:items-start lg:items-start md:w-[80%] lg:w-[80%]">
            <p className="text-[#ea5c35] font-bold text-xl mb-3 md:mb-8 lg:mb-8 lg:text-2xl">Curso UBE Academy Nexxmed</p>
            <p className="text-[#42525d] font-semibold text-3xl mb-3 md:mb-8 lg:mb-8 md:text-5xl lg:text-5xl">Domine a Endoscopia Biportal com prática em cadáver fresh frozen</p>
            <div className="flex items-center text-[#42525d] mb-2">
              <svg
                viewBox="0 0 384 512"
                xmlns="http://www.w3.org/2000/svg"
                fill="#ea5c35"
                className="w-5 h-5 mr-2"
              >
                <path d="M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z" />
              </svg>
              <p>ITC Jardins – São Paulo</p>
            </div>

            <div className="flex items-center text-[#42525d] mb-2">
              <svg
                viewBox="0 0 448 512"
                xmlns="http://www.w3.org/2000/svg"
                fill="#ea5c35"
                className="w-5 h-5 mr-2"
              >
                <path d="M400 64h-48V12c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v52H160V12c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v52H48C21.49 64 0 85.49 0 112v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm-6 400H54a6 6 0 0 1-6-6V160h352v298a6 6 0 0 1-6 6zm-52.849-200.65L198.842 404.519c-4.705 4.667-12.303 4.637-16.971-.068l-75.091-75.699c-4.667-4.705-4.637-12.303.068-16.971l22.719-22.536c4.705-4.667 12.303-4.637 16.97.069l44.104 44.461 111.072-110.181c4.705-4.667 12.303-4.637 16.971.068l22.536 22.718c4.667 4.705 4.636 12.303-.069 16.97z"></path>
              </svg>
              <p>Data: 11 e 12 de julho de 2025</p>
            </div>

            <div className="flex items-center text-[#42525d] mb-2">
              <svg
                viewBox="0 0 448 512"
                xmlns="http://www.w3.org/2000/svg"
                fill="#ea5c35"
                className="w-5 h-5 mr-2"
              >
                <path d="M352 240v32c0 6.6-5.4 12-12 12h-88v88c0 6.6-5.4 12-12 12h-32c-6.6 0-12-5.4-12-12v-88h-88c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h88v-88c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v88h88c6.6 0 12 5.4 12 12zm96-160v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"></path>
              </svg>
              <p>Prática em cadáver fresh frozen</p>
            </div>

            <div className="flex items-center text-[#42525d] mb-8">
              <svg
                viewBox="0 0 448 512"
                xmlns="http://www.w3.org/2000/svg"
                fill="#ea5c35"
                className="w-5 h-5 mr-2"
              >
                <path d="M313.6 304c-28.7 0-42.5 16-89.6 16-47.1 0-60.8-16-89.6-16C60.2 304 0 364.2 0 438.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-25.6c0-74.2-60.2-134.4-134.4-134.4zM400 464H48v-25.6c0-47.6 38.8-86.4 86.4-86.4 14.6 0 38.3 16 89.6 16 51.7 0 74.9-16 89.6-16 47.6 0 86.4 38.8 86.4 86.4V464zM224 288c79.5 0 144-64.5 144-144S303.5 0 224 0 80 64.5 80 144s64.5 144 144 144zm0-240c52.9 0 96 43.1 96 96s-43.1 96-96 96-96-43.1-96-96 43.1-96 96-96z"></path>
              </svg>
              <p>Coordenação: Dr. Bernardo Aramuni</p>
            </div>

            <div className="flex items-center justify-center text-center mb-8">
              <button onClick={handleClick} className="flex items-center justify-center text-center text-white bg-gradient-to-r from-[#ea5c35] to-[#f4b743] px-8 py-4 rounded-full font-bold">inscreva-se agora</button>
            </div>
          </div>
        </div>
      </div>
      <div className="w-[100%] flex flex-col">
        <div className="flex flex-col w-[100%] mt-5 items-center justify-center">
          <div className="flex flex-col w-[90%] text-center mb-8 md:w-[80%] lg:w-[70%]">
            <p className="text-3xl text-[#42525d] font-semibold mb-5 md:text-5xl lg:text-5xl">A capacitação definitiva em Endoscopia Biportal</p>
            <p className="mb-5 text-gray-500 md:text-lg lg:">Quando falamos de endoscopia biportal no Brasil, um nome se destaca:
              Dr. Bernardo Aramuni – com mais de 500 cirurgias realizadas e prática diária no centro cirúrgico.</p>
            <p className="mb-5 text-gray-500 md:text-lg lg:">Agora, o conhecimento de ponta chega até você com o curso mais completo e atualizado do país.</p>
            <p className="text-gray-500 md:text-lg lg:">A UBE Academy da Nexxmed será realizada no ITC Jardins, uma das estruturas mais avançadas para treinamento cirúrgico.</p>
          </div>
          <div className="mb-8 md:hidden lg:hidden">
            <img src="https://nexxmed.com.br/wp-content/uploads/2024/10/doctors-UBE-1.jpg" alt="" className="bg-gradient-to-t from-[#ea5c35] to-transparent w-[100%] h-[100%]" />
          </div>
        </div>
      </div>
      <div className="w-full flex justify-center md:justify-start lg:justify-start bg-white">
        <div className="hidden md:flex lg:flex md:w-[50%] lg:w-[50%] h-auto md:h-[700px] lg:h-[700px]">
          <img
            className="w-full h-full object-cover"
            src="https://nexxmed.com.br/wp-content/uploads/2024/10/doctors-UBE-1.jpg"
            alt=""
          />
        </div>
        <div className=" pt-8 lg:mb-10 flex flex-col w-[90%] md:w-[50%] lg:w-[50%] md:px-10 lg:px-10 text-center md:text-start lg:text-start lg:justify-center">
          <p className="text-2xl font-semibold text-[#42525d] mb-5 md:text-5xl lg:text-5xl lg:w-[60%]">O que você vai encontrar na UBE Academy?</p>
          <div className="flex mb-3 text-start justify-between">
            <svg
              viewBox="0 0 512 512"
              xmlns="http://www.w3.org/2000/svg"
              fill="#ea5c35"
              className="w-[5%] h-5 mr-2 text-[#42525d]"
            >
              <path d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z" />
            </svg>
            <p className="w-[90%] text-gray-500">Prática intensiva em cadáver fresh frozen</p>
          </div>
          <div className="flex mb-3 text-start justify-between">
            <svg
              viewBox="0 0 512 512"
              xmlns="http://www.w3.org/2000/svg"
              fill="#ea5c35"
              className="w-[5%] h-5 mr-2 text-[#42525d]"
            >
              <path d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z" />
            </svg>
            <p className="w-[90%] text-gray-500">8 estações cirúrgicas com no máximo 4 alunos por estação</p>
          </div>
          <div className="flex mb-3 text-start justify-between">
            <svg
              viewBox="0 0 512 512"
              xmlns="http://www.w3.org/2000/svg"
              fill="#ea5c35"
              className="w-[5%] h-5 mr-2 text-[#42525d]"
            >
              <path d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z" />
            </svg>
            <p className="w-[90%] text-gray-500">Treinamento hands-on realista e supervisionado</p>
          </div>
          <div className="flex mb-3 text-start justify-between">
            <svg
              viewBox="0 0 512 512"
              xmlns="http://www.w3.org/2000/svg"
              fill="#ea5c35"
              className="w-[5%] h-5 mr-2 text-[#42525d]"
            >
              <path d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z" />
            </svg>
            <p className="w-[90%] text-gray-500">Professores experientes em cirurgia minimamente invasiva</p>
          </div>
          <div className="flex mb-3 text-start justify-between">
            <svg
              viewBox="0 0 512 512"
              xmlns="http://www.w3.org/2000/svg"
              fill="#ea5c35"
              className="w-[5%] h-5 mr-2 text-[#42525d]"
            >
              <path d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z" />
            </svg>
            <p className="w-[90%] text-gray-500">Acesso a equipamentos e instrumentais modernos</p>
          </div>
          <div className="flex mb-5 text-start justify-between">
            <svg
              viewBox="0 0 512 512"
              xmlns="http://www.w3.org/2000/svg"
              fill="#ea5c35"
              className="w-[5%] h-5 mr-2 text-[#42525d]"
            >
              <path d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z" />
            </svg>
            <p className="w-[90%] text-gray-500">Auditório de última geração para parte teórica</p>
          </div>
          <div className="flex items-center justify-center text-center mb-8 lg:justify-start">
            <button onClick={handleClick} className="flex items-center justify-center text-center text-white bg-gradient-to-r from-[#ea5c35] to-[#f4b743] px-8 py-4 rounded-full font-bold">inscreva-se agora</button>
          </div>
        </div>
      </div>
      <div className="flex flex-col items-center w-[100%]">
        <div className="flex items-center justify-center text-center pt-5 mb-5">
          <p className="text-[#42525d] text-2xl font-semibold md:text-5xl lg:text-5xl">Conteúdo abordado no curso</p>
        </div>
        <div className="flex flex-col items-center justify-between w-[90%] md:flex-row lg:flex-row md:justify-evenly lg:justify-evenly md:items-stretch lg:items-stretch">
          <div className="flex flex-col justify-center bg-white rounded-3xl p-5 w-[100%] text-center mb-5 md:w-[45%] lg:w-[40%]">
            <p className="text-xl font-semibold text-[#ea5c35]">Dia 1 – Abordagem Interlaminar</p>
            <ul className="flex flex-col justify-start text-sm text-gray-500 font-medium text-start items-start mt-5 w-[100%]">
              <li className="mb-3">1. Princípios da Endoscopia Biportal (UBE)</li>
              <li className="ml-5 mb-3">- Portais, fluxo de soro e indicações</li>
              <li className="ml-5 mb-3">- Ministrado por Dr. Bernardo Aramuni</li>
              <li className="mb-3">2. UBE para Hérnia de Disco Lombar</li>
              <li className="ml-5 mb-3">- Indicações, técnica cirúrgica e cuidados pós-operatórios</li>
              <li className="ml-5 mb-3">- Ministrado por Dr. Ian Bustorff</li>
              <li className="mb-3">3. UBE para Canal Estreito Lombar</li>
              <li className="ml-5 mb-3">- Estratégias de descompressão e manejo anatômico</li>
              <li className="ml-5 mb-3">- Ministrado por Dr. Tácito Mourão</li>
              <li className="mb-3">4. Complicações na UBE Interlaminar – Como Evitar</li>
              <li className="ml-5 mb-3">- Principais riscos, prevenção e manejo intraoperatório</li>
              <li className="ml-5 mb-3">- Ministrado por Dr. Michael Minsu Shu</li>
            </ul>
          </div>
          <div className="flex flex-col justify-center bg-white rounded-3xl p-5 w-[100%] text-center mb-5 md:w-[45%] lg:w-[40%] md:justify-start lg:justify-start">
            <p className="text-xl font-semibold text-[#ea5c35]">Dia 2 – Abordagem Paraespinhal</p>
            <ul className="flex flex-col justify-start text-sm text-gray-500 font-medium text-start items-start mt-5 w-[100%]">
              <li className="mb-3">1. Princípios da UBE Paraespinhal</li>
              <li className="ml-5 mb-3">- Diferenças técnicas e indicações específicas</li>
              <li className="ml-5 mb-3">- Ministrado por Dr. Michael Minsu Shu</li>
              <li className="mb-3">2. UBE para Estenose de Forame</li>
              <li className="ml-5 mb-3">- Técnica para descompressão foraminal e cuidados com estruturas adjacentes</li>
              <li className="ml-5 mb-3">- Ministrado por Dr. Ian Bustorff</li>
              <li className="mb-3">3. UBE para Artrodese Lombar</li>
              <li className="ml-5 mb-3">- Aplicações em fusão minimamente invasiva</li>
              <li className="ml-5 mb-3">- Ministrado por Dr. Tácito Mourão</li>
              <li className="mb-3">4. UBE em Doenças Complexas da Coluna</li>
              <li className="ml-5 mb-3">- Casos desafiadores e abordagem estratégica</li>
              <li className="ml-5 mb-3">- Ministrado por Dr. Bernardo Aramuni</li>
            </ul>
          </div>
        </div>
      </div>
      <div className="flex flex-col justify-center items-center text-center w-[100%] lg:h-screen">
        <div className="flex flex-col justify-center items-center text-center w-[90%]">
          <p className="text-[#42525d] text-2xl font-semibold mb-3 md:text-5xl lg:text-5xl">Por que dominar a endoscopia biportal agora?</p>
          <p className="mb-3 text-gray-500 md:text-lg lg:text-lg">A rotina dos centros cirúrgicos mudou. Eficiência, tempo e resultado clínico nunca foram tão importantes.</p>
          <p className="mb-3 text-gray-500 md:text-lg lg:text-lg">Com a técnica biportal, você oferece:</p>
        </div>
        <div className="flex flex-col justify-evenly w-[100%] h-full items-center lg:flex-row lg:justify-evenly ">
          <div className="flex flex-col justify-end w-[90%] h-[20%] bg-gray-500 rounded-xl bg-cover bg-center bg-no-repeat lg:w-[23%] lg:h-[80%]" style={{ backgroundImage: "url('https://nexxmed.com.br/wp-content/uploads/2025/04/equipe-de-cirurgioes-de-uniforme-realiza-uma-operacao-em-um-paciente-em-uma-clinica-de-cirurgia-cardiaca-medicina-moderna-uma-equipe-profissional-de-saude-de-cirurgioes_657921-62.jpg')" }}>
            <div className="flex w-[100%] h-[100%] bg-gradient-to-t from-[#384853] to-transparent px-4 py-4 rounded-xl items-end">
              <div className="flex border-[1px] border-white w-[100%] h-[45%] lg:h-[30%] rounded-lg bg-transparent items-center justify-center px-2">
                <svg
                  viewBox="0 0 512 512"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="#ea5c35"
                  className="w-4 h-4 items-center justify-center text-center mr-2 text-[#42525d]"
                >
                  <path d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z" />
                </svg>
                <p className="font-semibold text-start w-[85%] text-md text-white">Cirurgias mais rápidas</p>
              </div>
            </div>
          </div>
          <div className="flex flex-col justify-end w-[90%] h-[20%] bg-gray-500 rounded-xl bg-cover bg-center bg-no-repeat lg:w-[23%] lg:h-[80%]" style={{ backgroundImage: "url('https://nexxmed.com.br/wp-content/uploads/2024/11/physio-arm-check-senior-man-with-rehabilitation-conversation-healthcare-clinic-consultation-client-elderly-care-with-physical-therapy-wellness-injury-support-with-chiropractor_590464-423045.jpg')" }}>
            <div className="flex w-[100%] h-[100%] bg-gradient-to-t from-[#384853] to-transparent px-4 py-4 rounded-xl items-end">
              <div className="flex border-[1px] border-white w-[100%] h-[45%] lg:h-[30%] rounded-lg bg-transparent items-center justify-center px-2">
                <svg
                  viewBox="0 0 512 512"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="#ea5c35"
                  className="w-4 h-4 items-center justify-center text-center mr-2 text-[#42525d]"
                >
                  <path d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z" />
                </svg>
                <p className="font-semibold text-start w-[85%] text-md text-white">Pós-operatório mais confortável</p>
              </div>
            </div>
          </div>
          <div className="flex flex-col justify-end w-[90%] h-[20%] bg-gray-500 rounded-xl bg-cover bg-center bg-no-repeat lg:w-[23%] lg:h-[80%]" style={{ backgroundImage: "url('https://nexxmed.com.br/wp-content/uploads/2024/10/UBE-2.jpg')" }}>
            <div className="flex w-[100%] h-[100%] bg-gradient-to-t from-[#384853] to-transparent px-4 py-4 rounded-xl items-end">
              <div className="flex border-[1px] border-white w-[100%] h-[45%] lg:h-[30%] rounded-lg bg-transparent items-center justify-center px-2">
                <svg
                  viewBox="0 0 512 512"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="#ea5c35"
                  className="w-4 h-4 items-center justify-center text-center mr-2 text-[#42525d]"
                >
                  <path d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z" />
                </svg>
                <p className="font-semibold text-start w-[90%] text-md text-white">Maior número de casos operados</p>
              </div>
            </div>
          </div>
          <div className="flex flex-col justify-end w-[90%] h-[20%] bg-gray-500 rounded-xl bg-cover bg-center bg-no-repeat lg:w-[23%] lg:h-[80%]" style={{ backgroundImage: "url('https://nexxmed.com.br/wp-content/uploads/2024/09/concentrated-professional-surgical-doctor-team-operating-surgery-patient-operating-room-hospital-healthcare-medical-concept-1.jpg')" }}>
            <div className="flex w-[100%] h-[100%] bg-gradient-to-t from-[#384853] to-transparent px-4 py-4 rounded-xl items-end">
              <div className="flex border-[1px] border-white w-[100%] h-[45%] lg:h-[30%] rounded-lg bg-transparent items-center justify-center px-2 py-2">
                <svg
                  viewBox="0 0 512 512"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="#ea5c35"
                  className="w-4 h-4 items-center justify-center text-center mr-2 text-[#42525d]"
                >
                  <path d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z" />
                </svg>
                <p className="font-semibold text-start w-[85%] text-md text-white">Mais valor para sua prática profissional</p>
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-col justify-center items-center w-[90%]">
          <p className="text-[#42525d] text-2xl font-semibold mb-8">Quem domina, opera mais. Quem aprende agora, sai na frente.</p>
          <button onClick={handleClick} className="flex mb-8 items-center justify-center text-center text-white bg-gradient-to-r from-[#ea5c35] to-[#f4b743] px-8 py-4 rounded-full font-bold">inscreva-se agora</button>
        </div>
      </div>
      <div className="flex flex-col justify-center items-center text-center bg-[#ea5c35] w-[100%] py-14 px-5">
        <p className="text-2xl text-white font-bold mb-5 md:text-5xl lg:text-5xl">Um treinamento para quem quer resultado</p>
        <p className="text-white md:text-lg lg:text-lg md:w-[80%] lg:w-[80%]">Nada de teoria solta. Você aprende com quem <span className="font-bold">vive a técnica todos os dias</span>, em um ambiente controlado, 100% voltado para a excelência cirúrgica.</p>
      </div>
      <div className="flex flex-col items-center py-8 w-[100%] px-2">
        <p className="text-[#42525d] text-2xl font-semibold mb-8 md:text-5xl lg:text-5xl">Conheça os professores</p>
        <div className="flex flex-wrap justify-evenly">
          <div className="flex flex-col bg-white rounded-xl px-4 pb-4 max-w-[45%] lg:w-[30%] mb-8 lg:items-center">
            <div className="rounded-lg mb-3 flex justify-center">
              <img
                src="https://nexxmed.com.br/wp-content/uploads/2025/05/Dr.-Bernardo-Aramuni.png"
                alt="Dr. Bernardo Aramuni"
                className="w-[100%] lg:w-[60%] max-w-[381px] h-auto"
                width={381}
                height={630}
              />
            </div>
            <div className="flex flex-col justify-center items-center text-center ">
              <p className="font-bold text-[#42525d] text-xl mb-3">Dr. Bernardo Aramuni</p>
              <p className="text-gray-500">Especialista em UBE - Endoscopia Biportal de Coluna. Neurocirurgião com Residência médica em Neurocirurgia pelo Hospital Municipal Odilon Behrens, em Belo Horizonte, MG.</p>
            </div>
          </div>
          <div className="flex flex-col bg-white rounded-xl px-4 pb-4 max-w-[45%] lg:w-[30%] mb-8 lg:items-center">
            <div className="rounded-lg mb-3 flex justify-center">
              <img
                src="https://nexxmed.com.br/wp-content/uploads/2025/05/Dr.-Ian-Bustorff-Freire.png"
                alt="Dr. Ian Bustorff Freire"
                className="w-full lg:w-[60%] max-w-[381px] h-auto"
                width={381}
                height={630}
              />
            </div>
            <div className="flex flex-col justify-center items-center text-center">
              <p className="font-bold text-[#42525d] text-xl mb-3">Dr. Ian Bustorff Freire</p>
              <p className="text-gray-500">Ortopedista e traumatologista especializado em cirurgia minimamente invasiva da coluna, com atuação em São Paulo e participação ativa em cursos e congressos sobre UBE.</p>
            </div>
          </div>
          <div className="flex flex-col bg-white rounded-xl px-4 pb-4 max-w-[45%] lg:w-[30%] mb-8 lg:items-center">
            <div className="rounded-lg mb-3 flex justify-center">
              <img
                src="https://nexxmed.com.br/wp-content/uploads/2025/05/Dr.-Michael-Minsu-Shu.png"
                alt="Dr. Michael Minsu Shu"
                className="w-full lg:w-[60%] max-w-[381px] h-auto"
                width={381}
                height={630}
              />
            </div>
            <div className="flex flex-col justify-center items-center text-center">
              <p className="font-bold text-[#42525d] text-xl mb-3">Dr. Michael Minsu Shu</p>
              <p className="text-gray-500">Ortopedista com múltiplos fellowships em cirurgia endoscópica de coluna na Coreia do Sul, especialista em técnicas minimamente invasivas e coordenador de cursos práticos de UBE no Brasil.</p>
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-col w-[100%] bg-gradient-to-b from-[#f9cb48] to-[#ea5c35] px-4 py-8">
        <div className="flex flex-col text-white mb-5 justify-center items-center text-center md:flex-row lg:flex-row w-full">
          <p className="font-bold text-2xl md:text-5xl lg:text-5xl md:hidden lg:hidden">Local do curso</p>

          <div className="text-start my-8 w-[90%] md:w-[50%] lg:w-[45%] md:pl-8">
            <p className="font-bold text-2xl md:text-5xl lg:text-5xl hidden md:flex lg:flex md:mb-8 lg:mb-8">Local do curso</p>

            <div className="flex mb-3 text-start ">
              <svg
                viewBox="0 0 384 512"
                xmlns="http://www.w3.org/2000/svg"
                fill="#ea5c35"
                className="w-[5%] h-5 mr-2"
              >
                <path d="M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z" />
              </svg>
              <p className="w-[90%]">ITC Jardins – São Paulo</p>
            </div>
            <div className="flex mb-3 text-start">
              <svg
                viewBox="0 0 512 512"
                xmlns="http://www.w3.org/2000/svg"
                fill="#ea5c35"
                className="w-[5%] h-5 mr-2 text-[#42525d]"
              >
                <path d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z" />
              </svg>
              <p className="w-[90%]">Ambiente premium</p>
            </div>
            <div className="flex mb-3 text-start">
              <svg
                viewBox="0 0 512 512"
                xmlns="http://www.w3.org/2000/svg"
                fill="#ea5c35"
                className="w-[5%] h-5 mr-2 text-[#42525d]"
              >
                <path d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z" />
              </svg>
              <p className="w-[80%] text-wrap">Estrutura completa e foco total em ensino prático.</p>
            </div>
          </div>
          <div className="flex flex-col w-[90%] md:w-[50%] lg:w-[50%]">
            <div className="flex flex-row flex-wrap justify-between gap-3 mb-5">
              <div className="w-[48%] aspect-square md:aspect-[3/4] lg:aspect-square">
                <img className="rounded-xl object-cover w-full h-full lg:aspect-square" src="https://nexxmed.com.br/wp-content/uploads/2025/05/Decupagem.00_04_57_23.Still015.jpg" />
              </div>
              <div className="w-[48%] aspect-square md:aspect-[3/4] lg:aspect-square">
                <img className="rounded-xl object-cover w-full h-full lg:aspect-square" src="https://nexxmed.com.br/wp-content/uploads/2025/05/Decupagem.00_01_49_07.Still010.jpg" />
              </div>
            </div>
            <div className="flex flex-col md:flex-row lg:flex-row justify-between gap-3">
              <div className="w-full lg:w-[48%] aspect-[3/4] lg:aspect-square">
                <img className="rounded-xl object-cover w-full h-full aspect-[3/4] lg:aspect-square" src="https://nexxmed.com.br/wp-content/uploads/2025/05/Decupagem.00_00_26_05.Still004.jpg" />
              </div>
              <div className="w-full lg:w-[48%] aspect-[3/4] lg:aspect-square">
                <img className="rounded-xl object-cover w-full h-full aspect-[3/4] lg:aspect-square" src="https://nexxmed.com.br/wp-content/uploads/2025/05/Decupagem.00_04_13_06.Still013.jpg" />
              </div>
            </div>
          </div>
        </div>
        <div className="lg:w-[100%]">
          <FAQAccordion />
        </div>
      </div>
      <div className="flex flex-col bg-[#242d33] text-white justify-center items-center text-center py-16 px-4">
        <img src="https://nexxmed.com.br/wp-content/uploads/2024/09/logo_nexxmed_2-1.png" alt="" className="w-[50%] md:w-[20%] mb-8" />
        <p className="mb-5">Copyright 2025 ©️ Nexxmed - Todos os direitos reservados</p>
        <p className="text-sm font-thin">Desenvolvido por <a href="https://maincode.dev">MainCode Software</a></p>
      </div>
    </div >
  );
};

export default Homepage;
